import React, { useContext, useState } from 'react';
import classes from './PlantLocations.module.css';
import { FlexContainer, Column, Row } from '../../../Shared/FlexDiv/FlexDiv';
import { Uppercase } from '../../../../Utility';
import mixpanel from 'mixpanel-browser';
import { Urls } from '../../../../Urls';
import { UserApiContext } from '../../../UserDetailsContext/UserDetailsContext';

const PlantLocations = ({ plantLocations = [], requestDataForLocation }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { userDetails } = useContext(UserApiContext)
  const plantLocationClicked = () => {
    mixpanel.track(`User has clicked on my plant locations`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: 'LoRRI-Locationdashboard',
      ModuleName: 'landing_page',
      ActivityLog: 'userClickedMyPlantLocations',
      Data: `None`,
      Definition: `User has clicked on my plant locations`,
      ActivityType: 'page_view',
      UserName: `${userDetails?.user_name}`,
      UserEmail: `${userDetails?.email}`,
      CompanyName: userDetails.company_name
        ? userDetails.company_name
        : userDetails.email
          ? userDetails.email.split("@")[1].split(".")[0]
          : ""
    });

    setIsOpen((prev) => !prev); // toggle accordion open/close
  };

  const handleLocationClick = (item) => {
    requestDataForLocation(item, 'Plant');
    setIsOpen(false); // optional: close when user selects one
  };

  return (
    <FlexContainer>
      <div>
        {/* <Row className={classes['justify-content-center']}>
          <button
            type="button"
            onClick={plantLocationClicked}
            className={`btn btn-success btn-block ${classes['standardbtn']}`}
          >
            My Plant Locations
          </button>
        </Row> */}

        <Row
          className={`${classes['Container']} ${classes.collapseContent} ${isOpen ? classes.show : ''
            }`}
        >
          <Column style={{ width: "100%" }}>
            {plantLocations.map((item, index) => (
              <span
                key={index}
                onClick={() => handleLocationClick(item)}
                className={classes["plantLocationItem"]}
              >
                {Uppercase(`${item.location}, ${item.state}`)}
              </span>
            ))}
          </Column>
        </Row>
      </div>
    </FlexContainer>
  );
};

export default PlantLocations;
